import { RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { changeStepRequest, setStepTitle } from '../../../reducers/checkout';
import { Button, Section, SectionHeader, StepNumber } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './Step.scss';

interface IOwnProps {
  stepNumber: number;
  title: string;
  active: boolean;
  completed: boolean;
  stepMessage?: string;
  groupTitle?: string;
  buttonLabel?: string;
  last?: boolean;
}

interface IWrapperInjectedProps {
  readOnly: boolean;
}

interface IConnectedProps {
  isLoading: boolean;
}

interface IConnectetDispatchProps {
  changeStepRequest: typeof changeStepRequest;
  setStepTitle: typeof setStepTitle;
}

type Props = IOwnProps & IWrapperInjectedProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

const Step = <InjectedProps extends Props>(WrappedComponent: React.ComponentType<InjectedProps>) => {
  class AsStep extends React.Component<InjectedProps, {}> {

    /* componentDidMount() {
      const { active, title } = this.props;

      if (active) {
        this.props.setStepTitle({ title });
      }
    } */ // TODO - think about different way to handle this

    edit = () => {
      const { completed } = this.props;

      if (completed) {
        this.setStepActive();
      }
    }

    setStepActive = () => {
      const { stepNumber, completed } = this.props;

      if (completed) {
        this.props.changeStepRequest({ step: stepNumber });
      }
    }

    render() {
      const { title, active, completed, stepMessage, buttonLabel, stepNumber, last, isLoading, intl } = this.props;
      const { formatMessage } = intl;

      const stepClassNames = cx({
        [Styles.step]: true,
        [Styles.completed]: completed
      });

      return (
        <div className={stepClassNames} onClick={this.edit}>
          <div className={Styles.header} onClick={this.setStepActive}>
            <StepNumber accent={active} icon={completed} step={stepNumber} />
            <SectionHeader accent={active} title={title} light={!active} />
            {completed && (
              <div className={Styles.editButton}>
                <Button align="center" type="button" variant="clear" size="small" label={formatMessage(messages.step_edit)} onClick={this.setStepActive} />
              </div>
            )}
          </div>
          {!completed && active && (
            <div className={Styles.edit}>
              {stepMessage && (
                <Section>
                  <p className={Styles.stepMessage}>{stepMessage}</p>
                </Section>
              )}
              <div className={Styles.content}>
                <WrappedComponent {...this.props} />
              </div>
              {!last && buttonLabel && (
                <Section>
                  <div className={Styles.button}>
                    <Button align="center" type="submit" variant="primary" isLoading={isLoading} label={buttonLabel} />
                  </div>
                </Section>
              )}
            </div>
          )}
          {completed && (
            <div className={Styles.readOnly} onClick={this.setStepActive}>
              <WrappedComponent {...this.props} readOnly={completed} />
            </div>
          )}
        </div>
      );
    }
  }

  return compose<React.ComponentClass<IOwnProps>>(
    injectIntl,
    connect<IConnectedProps, IConnectetDispatchProps>(
      (state: RootState) => ({
        isLoading: state.checkout.steps.isLoading,
      }),
      {
        changeStepRequest,
        setStepTitle
      }
    ),
  )(AsStep);
};

export default Step;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Step/Step.tsx